import { render, staticRenderFns } from "./service-list.vue?vue&type=template&id=6fe7989e&scoped=true"
import script from "./service-list.vue?vue&type=script&lang=js"
export * from "./service-list.vue?vue&type=script&lang=js"
import style0 from "./service-list.vue?vue&type=style&index=0&id=6fe7989e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7989e",
  null
  
)

export default component.exports